import React from 'react';
import { DownloadIcon, GlobeIcon, LockIcon } from 'lucide-react';
const notes = [{
  label: '100 % sichere, verschlüsselte Zahlung',
  Icon: LockIcon
}, {
  label: 'Abrechnung automatisch in deiner Landeswährung',
  Icon: GlobeIcon
}, {
  label: 'Digitaler Download direkt nach dem Kauf',
  Icon: DownloadIcon
}];

/** Reassurance shown right under the checkout button. */
export function SecurePaymentNote({
  className = ''
}: {
  className?: string;
}) {
  return <ul role="list" className={`mx-auto flex w-full max-w-[420px] flex-col gap-2.5 rounded-[14px] border border-brand-cta/25 bg-brand-cta/[0.06] px-5 py-4 text-left ${className}`} data-id="element-162" data-mp="1m5lxi36j5bt9">
      {notes.map(({
      label,
      Icon
    }) => <li key={label} className="flex items-center gap-2.5 font-body text-[13px] font-semibold text-brand-charcoal" data-id="element-163" data-mp="1zz33sma7gs1c">
          <Icon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2} aria-hidden="true" data-id="element-164" data-mp="24z7lugqrhuto" />
          {label}
        </li>)}
    </ul>;
}